import CreateReducers from '../helpers/createReducers.js';
import initialState from './initialState.js';

 
const headerReducer = CreateReducers(initialState.customer, {
  'LOAD_CUSTOMER_SUCESS': (state, { customer }) => ({
    ...customer
  }),
  'customer_load__Failure': (state, {error}) => ({
    ...state,
    error
  })
});


export default headerReducer;

